import {Component, EventEmitter, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {AccessibilityService} from "../../services/accessibility.service";
import {take} from "rxjs";

@Component({
  selector: 'brt-accessibility-menu',
  templateUrl: './accessibility-menu.component.html',
  styleUrls: ['./accessibility-menu.component.scss']
})
export class AccessibilityMenuComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();

  currentScaleValue = 1;
  currentTextScaleValue = 1;
  initialGrayscaleValue = false;
  initialHighContrastValue = false;
  stopMovingContent = false;
  textSpacing = false;

  constructor(private accessibilityService: AccessibilityService) {
    this.accessibilityService.getScaleValue().pipe(take(1)).subscribe((value) => {
       this.currentScaleValue = value;
    });

    this.accessibilityService.getTextScaleValue().pipe(take(1)).subscribe((value) => {
      this.currentTextScaleValue = value;
    });

    this.accessibilityService.getGrayscaleValue().pipe(take(1)).subscribe((value) => {
      this.initialGrayscaleValue = value;
    });

    this.accessibilityService.getHighContrastValue().pipe(take(1)).subscribe((value) => {
      this.initialHighContrastValue = value;
    });

    this.accessibilityService.getStopMovingContent().pipe(take(1)).subscribe((value) => {
      this.stopMovingContent = value;
    });

    this.accessibilityService.getTextSpacingValue().pipe(take(1)).subscribe((value) => {
      this.textSpacing = value;
    });
  }
  onContrastStateChanged($event: boolean) {
    this.accessibilityService.updateHighContrastValue($event);
  }

  onTextSpacingChanged($event: boolean) {
    this.accessibilityService.updateTextSpacingValue($event);
  }

  onGrayscaleChanged($event: boolean) {
    this.accessibilityService.updateGrayscaleValue($event);
  }

  prevStepScaleValue() {
    let value = this.accessibilityService.getPrevStepScaleValue();
    this.currentScaleValue = this.accessibilityService.updateScaleValue(value);
  }

  nextStepScaleValue() {
    let value = this.accessibilityService.getNextStepScaleValue();
    this.currentScaleValue = this.accessibilityService.updateScaleValue(value);
  }

  prevStepTextScaleValue() {
    let value = this.accessibilityService.getPrevStepTextScaleValue();
    this.currentTextScaleValue = this.accessibilityService.updateTextScaleValue(value);
  }

  nextStepTextScaleValue() {
    let value = this.accessibilityService.getNextStepTextScaleValue();
    this.currentTextScaleValue = this.accessibilityService.updateTextScaleValue(value);
  }

  protected readonly AccessibilityService = AccessibilityService;

  onFocusLose($event: FocusEvent, currentElement: HTMLButtonElement, nextElement: HTMLButtonElement) {
    console.log($event);
    console.log($event.relatedTarget);
    if($event.relatedTarget === null) { // assuming on disabled
      console.log(nextElement);
      nextElement.focus();
    }
  }

  resetScaleValue() {
    this.currentScaleValue = this.accessibilityService.resetScaleValue();
  }

  resetTextScaleValue() {
    this.currentTextScaleValue = this.accessibilityService.resetTextScaleValue();
  }

  onStopMovingContentChanged($event: boolean) {
    this.accessibilityService.updateStopMovingContent($event);
  }
}
